class MainPage extends HTMLElement {
  static observedAttributes = ["layout"];

  constructor() {
    super();
    this.scrollToLink = this.scrollToLink.bind(this);

    this.checkContactPage();
  }

  connectedCallback() {
    const layout = this.getAttribute("layout");

    if (layout !== "sub_nav") return;

    const sectionLinks = this.querySelector("[data-sectionlinks]");

    document.querySelectorAll("[data-sectionid]")?.forEach((section) => {
      const link = document.createElement("a");
      link.innerHTML = section.getAttribute("data-sectionid") ?? "";
      link.href = "#" + section.getAttribute("id");

      link.addEventListener("click", this.scrollToLink);

      sectionLinks?.append(link);
    });
  }

  checkContactPage() {
    const currentPage = this.getAttribute("current-page");

    if (currentPage === "contact") {
      const urlParams = new URLSearchParams(window.location.search);

      if (urlParams.get("contact_posted") === "true") {
        [this.querySelector(".main-page-title"), this.querySelector(".page__content")].forEach(
          (el) => ((el as HTMLElement).style.display = "none")
        );
      }
    }
  }

  scrollToLink(e: Event) {
    e.preventDefault();

    const elem = document.querySelector(e.target?.getAttribute("href"));

    elem?.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "nearest",
    });
  }
}

customElements.define("main-page", MainPage);
